import { createContext, useContext } from 'react';

interface ModalContextValue {
  /** Закрыть текущую модалку изнутри */
  close: () => void;
  /** Свернуть текущую модалку в док (состояние формы сохраняется) */
  minimize: () => void;
}

export const ModalContext = createContext<ModalContextValue | null>(null);

/**
 * useCloseModal — хук для закрытия модалки изнутри её контента.
 * Работает только внутри компонента, отрендеренного через useModal().
 */
export function useCloseModal(): ModalContextValue {
  const ctx = useContext(ModalContext);
  if (!ctx) {
    throw new Error(
      'useCloseModal() вызван вне контекста модалки. Используйте только внутри компонентов, открытых через useModal().'
    );
  }
  return ctx;
}
